import React, { useState, useEffect } from 'react';
import { Browser } from '../../../services/helpers/Browser';
import DeviceTypeEnum from '../../../constants/DeviceTypeEnum';
import { template } from '../../../constants/Configs';
import { LanguageService } from '../../../services/LanguageService';
import { useSelector } from 'react-redux';
import { LocalStorageService } from '../../../services/LocalStorageService';

const StorageKey = 'app_advisor_terminated'
const isiOS = Browser.getDeviceTypeByUserAgent(window.navigator.userAgent) === DeviceTypeEnum.MobileIOS

const AppAdviser = ({ onHide, setShowAppAdviser }) => {
  const { isLoading: isTranslationLoading = true } = useSelector(state => state.translations)
  const logo = useSelector(state => state.settings.logo.appLogoUrl || {})
  const data = useSelector(state => state.settings.mobileAppSuggestion || state.settings.appAdviserSettings ||  {})
  const [show, setShow] = useState(false)
  const logoUrl = logo.value ? `/${logo.value}?v=${logo.lastUpdateTime}` : null
  const appName = data.applicationName

  useEffect(() => {
    if (Object.keys(data).length && !isTranslationLoading) {
      const isVisable = (!LocalStorageService.get(StorageKey) && data.showAppAdviser && getAppUrl())
      // TODO: improve and move to Utils
      setShowAppAdviser(isVisable)
      setShow(isVisable)
    }
  }, [data, isTranslationLoading]);

  const getAppUrl = () => {
    let url = null
    if (data.usesGeneralUrl) {
      url = data.generalUrl
    } else if (isiOS) {
      url = data.appStoreUrl
    } else {
      url = data.playStoreUrl
    }
    return url
  }

  const onClose = () => {
    LocalStorageService.set(StorageKey, true)
    setShow(false);
    onHide(false)
  }

  const openApp = () => {
    location.assign(getAppUrl());
  }

  return show ? (
    <div className={`tb--app-banner tb--app-banner${template}`}>
      <div className='tb--flex tb--align-center'>
        {logoUrl && <div className='tb--app-logo'><img src={logoUrl} alt={logo.name} /></div>}
        <div className='tb--app-desc tb--ellipsis'>
          <div className='tb--app-name tb--ellipsis'>{appName}</div>
          <div className='tb--app-text tb--ellipsis'>{LanguageService.getTranslation('applicationText')}</div>
        </div>
      </div>
      <button onClick={openApp} className="tb--btn-app">
        {LanguageService.getTranslation('useApp')}
      </button >
      <i className="digi_icon-close" onClick={onClose}></i>
    </div>
  ) : <></>;
};

export default AppAdviser;
